import { IChatVoice } from "../components/voices/types";

export const getVoiceById = (voices: IChatVoice[], id: string): IChatVoice | null => {
  if (!voices || !id) {
    return null;
  }
  const voice = voices?.filter((voice) => voice?.id === id);
  return voice?.[0] || null;
};
